import { connect } from 'react-redux';
import { logoutUser } from '../../../store/action/userAction';
import { DOMAIN_POS_VIETTELMEDIA } from '../../../config/config';


const Settings = (props) => {
   const { logoutUser, user } = props;

   return (
      <div className="app-popover app-popover-hidden-arrow app-popover-placement-rightBottom" style={{
         left: 25,
         top: -120
      }}>
         <div className="app-popover-content">
            <div className="app-popover-arrow"></div>
            <div className="app-popover-inner" role="tooltip">
               <div>
                  <div className="app-popover-inner-content">
                     <div className="app-messaging-first--menu-item--account-list">
                        <div className="app-messaging-first--account--wrapper  app-messaging-first--account--list-account">
                           <div className="">
                              <div className="app-messaging-first--menu-item--account-item-container app-messaging-first--account--list-account--container">
                                 <div className="app-messaging-first--menu-item--account--icon away-mode">
                                    <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
                                       <path fill="#6C798F" fillRule="evenodd" d="M9.248 9.01a3 3 0 100-6 3 3 0 100 6zm0 1.5c-2.003 0-6 1.005-6 3v1.5h12v-1.5c0-1.995-3.998-3-6-3z"
                                          clipRule="evenodd">
                                       </path>
                                    </svg>
                                 </div>
                                 <div className="app-messaging-first--menu-item--account--title">
                                    <div
                                       className="app-messaging-first--menu-item--account--title--name app-messaging-first--content-1-line"
                                       title="Doraemon">Tài khoản: {user.username}</div>
                                    <div
                                       className="app-messaging-first--menu-item--account--title--email app-messaging-first--content-1-line"
                                       title={user.username}>
                                       {user.username}
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div className="app-messaging-first--line top-org-info"></div>
                        <a href={DOMAIN_POS_VIETTELMEDIA} target="_blank" className="app-messaging-first--org-info-link">
                           <div className="app-messaging-first--account--wrapper app-messaging-first--org-info--container">
                              <div className="app-messaging-first--org-info--icon">
                                 <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
                                    <path fill="#6C798F"
                                       d="M16.016 8.298v5.962c0 .413-.146.766-.44 1.06-.294.293-.647.44-1.06.44h-10.5c-.412 0-.765-.147-1.059-.44a1.444 1.444 0 01-.44-1.06V8.298c-.288-.263-.51-.6-.666-1.013-.156-.412-.16-.862-.01-1.35l.788-2.55c.1-.325.278-.593.534-.806.257-.213.553-.319.89-.319H14.48c.337 0 .631.103.881.31.25.206.431.478.544.815l.787 2.55c.15.488.147.932-.009 1.332s-.378.743-.666 1.03zm-5.1-.788c.338 0 .594-.115.77-.347.174-.23.243-.49.205-.778L11.48 3.76h-1.463v2.775c0 .263.088.49.263.685.175.193.387.29.637.29zm-3.375 0a.92.92 0 00.704-.29.969.969 0 00.271-.685V3.76H7.054L6.64 6.385a.95.95 0 00.197.788.862.862 0 00.703.337zm-3.337 0a.825.825 0 00.59-.244c.17-.162.272-.368.31-.618l.412-2.888H4.054l-.75 2.513c-.075.25-.034.519.122.806.156.288.415.431.778.431zm10.125 0c.362 0 .625-.143.787-.431.163-.287.2-.556.113-.806L14.44 3.76h-1.425l.413 2.888c.037.25.14.456.31.619a.825.825 0 00.59.243zM4.016 14.26h10.5V8.973a.452.452 0 01-.121.037h-.066c-.338 0-.635-.056-.89-.168a2.531 2.531 0 01-.76-.544c-.225.225-.481.4-.769.525a2.28 2.28 0 01-.919.187 2.393 2.393 0 01-1.725-.712c-.212.225-.459.4-.74.525a2.214 2.214 0 01-.91.187 2.49 2.49 0 01-.984-.187 2.443 2.443 0 01-.778-.525c-.263.262-.522.447-.778.553-.256.106-.547.16-.872.16H4.12a.19.19 0 01-.104-.038v5.287z">
                                    </path>
                                 </svg>
                              </div>
                              <div className="app-messaging-first--org-info--name" title="Viettel Pos">
                                 Viettel Pos
                              </div>
                              <div className="app-messaging-first--ic-launch"><svg width="18" height="18" fill="none"
                                 viewBox="0 0 18 18">
                                 <path fill="#6C798F" fillRule="evenodd"
                                    d="M3.998 3.75v10.5h10.5V9h1.5v5.25c0 .825-.675 1.5-1.5 1.5h-10.5a1.5 1.5 0 01-1.5-1.5V3.75a1.5 1.5 0 011.5-1.5h5.25v1.5h-5.25zm6.75 0v-1.5h5.25V7.5h-1.5V4.808L7.125 12.18l-1.057-1.057L13.44 3.75h-2.692z"
                                    clipRule="evenodd"></path>
                              </svg></div>
                           </div>
                        </a>
                        <div className="app-messaging-first--line"></div>
                        <div className="app-messaging-first--account--wrapper app-messaging-first--account--logout pointer" onClick={logoutUser}>
                           <div className="app-messaging-first--menu-item--account-item-container app-messaging-first--logout">
                              <div className="app-messaging-first--menu-item--account--icon">
                                 <svg width="18" height="18" fill="none" viewBox="0 0 18 18">
                                    <path fill="#6C798F" d="M3.989 15.913c-.473 0-.875-.167-1.208-.5a1.645 1.645 0 01-.499-1.206V3.814c0-.472.167-.875.5-1.207a1.645 1.645 0 011.207-.5h5.294v1.707H3.99v10.393h5.294v1.706H3.99zm8.263-2.937l-1.18-1.227 1.886-1.886H6.917V8.157h6.041l-1.885-1.885 1.179-1.227 3.96 3.965-3.96 3.966z">
                                    </path>
                                 </svg>
                              </div>
                              <a className="app-messaging-first--menu-item--account--title" >
                                 Đăng xuất
                              </a>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

   );
};

const mapStateToProps = (state) => {
   const { user } = state;
   return {
      user
   };
};


export default connect(mapStateToProps, {
   logoutUser
})(Settings);
